import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { LoadMore, Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import ReactEcharts from 'echarts-for-react';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Http from 'services/http2';
import ModalService from 'services/modal';
import StatisticsFns from '../functions/statistics';
import Util from 'lib/util.js';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';

function SupplierDetail(props) {
  const Config = {
    purchase: {
      title: '供应商档案',
      apiPath: '/archives/compVendor/getDetailByUniqueCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Invite_Status',
          subKey: 'inviteStatus',
          value: 'inviteStatusName'
        },
        {
          mainKey: 'B02_Vendor_Status',
          subKey: 'vendorStatus',
          value: 'vendorStatusName'
        }
      ],
      idField: 'xkUniqueCode'
    }
  };

  const style1 = {
    image: {
      width: 60,
      height: 60,
      fontSize: 60,
      color: '#ddd'
    },
    img: {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%'
    },
    paper: {
      padding: 10,
      borderBottom: '1px solid #d9d9d9',
      margin: 'auto',
      maxWidth: '100%',
      marginBottom: 20
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [isShowDetail, setIsShowDetail] = useState(false);
  const [showTrendStatistic, setShowTrendStatistic] = useState(true);
  const [isShowList, setIsShowList] = useState(false);
  const [list, setList] = useState([]);
  const [gradeInfo, setGradeInfo] = useState('');
  const [perListChartTxt, setPerListChartTxt] = useState('查看历史绩效评定');
  const [chartOpt1, setCharOpt1] = useState({});
  const [indicatorMap, setIndicatorMap] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      getTrendStatistic();
    }
  };

  // 初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  // 根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //获取趋势图数据
  function getTrendStatistic() {
    let postbody = {
      apiPath: '/assessment/score/trendStatistic',
      vendorXkUniqueCode: self.id,
      companyCode: companyCode
    };

    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (data && data.length > 0) {
          let monthDate = data[data.length - 1].assessmentMonth;
          getRadarStatistic(monthDate);
          getList();
        } else {
          setShowTrendStatistic(false);
        }
      } else if (response.errorMsg) {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //获取单月指标雷达数据
  function getRadarStatistic(monthDate) {
    let postbody = {
      apiPath: '/assessment/score/radarStatistic',
      vendorXkUniqueCode: self.id,
      companyCode: companyCode,
      monthStart: monthDate,
      monthEnd: monthDate
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        data.forEach(item => {
          item.score = Util.precisionRound(item.score, 2);
        });
        renderRadar(data);
      } else if (response.errorMsg) {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //渲染单月指标雷达图
  function renderRadar(data) {
    if (Util.isEmpty(data)) {
      return;
    }
    let indicator = [];
    let seriesData = [];
    data.forEach(item => {
      indicatorMap[item.standardItemName] = item.standardItemCode;
      indicator.push({
        name: item.standardItemName + '\n' + item.score + '%',
        max: 100
      });
      seriesData.push(item.score);
    });
    let chartOpt1Data = StatisticsFns.getRadarOpt(
      indicator,
      seriesData,
      '供应体系综合能力'
    );
    setCharOpt1(chartOpt1Data);
  }

  function getList() {
    let postbody = {
      apiPath: '/assessment/score/vendorStatistic',
      companyCode: companyCode,
      vendorXkUniqueCode: self.id
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let lists = response.data.scoreList || [];
        if (!gradeInfo && lists.length > 0) {
          setGradeInfo(lists[0].gradeInfo);
        }
        setList(lists);
      }
    });
  }

  //切换列表和图表显示
  function listChartClick() {
    let data = !isShowList ? '查看当前综合绩效' : '查看历史绩效评定';
    setPerListChartTxt(data);
    setIsShowList(!isShowList);
  }

  const { classes } = props;

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className="supplierDetail">
      <TopNav inited={inited} />
      <Paper elevation={0} square={true} style={style1.paper}>
        <Grid container spacing={16}>
          <Grid item>
            <ButtonBase style={style1.image}>
              {detail.vendorLogo ? (
                <img style={style1.img} alt="complex" src={detail.vendorLogo} />
              ) : (
                <i className="icon-supplier"></i>
              )}
            </ButtonBase>
          </Grid>
          <Grid item xs={true} sm container>
            <Grid item xs container direction="column" spacing={16}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  {detail.innerVendorName}
                </Typography>
                <Typography color="textSecondary">
                  {detail.innerVendorAbbr}-{detail.innerVendorCode}
                </Typography>
                <Typography color="textSecondary">
                  携客企业号: {detail.vendorCode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <div className="order-detail-block">
        <div
          className="order-detail-title"
          onClick={() => {
            setIsShowDetail(!isShowDetail);
          }}
        >
          <label>供应商详情信息</label>
          <i
            className={[
              'iconRight',
              isShowDetail ? 'icon-down' : 'icon-more'
            ].join(' ')}
          ></i>
        </div>
        {isShowDetail ? (
          <ul>
            <li>
              <label className="order-detail-label">企业名称</label>
              <div className="order-detail-value">{detail.vendorName}</div>
            </li>
            <li>
              <label className="order-detail-label">企业简称</label>
              <div className="order-detail-value">{detail.vendorAbbr}</div>
            </li>
            <li>
              <label className="order-detail-label">供应商状态</label>
              <div className="order-detail-value">
                {detail.vendorStatusName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">邀约状态</label>
              <div className="order-detail-value">
                {detail.inviteStatusName}
              </div>
            </li>
          </ul>
        ) : (
          ''
        )}
      </div>

      <Card className="performanceInfo">
        <p style={{ padding: '10px', fontSize: '0.875rem' }}>供应商绩效</p>
        {!showTrendStatistic ? (
          <LoadMore showLine> 暂无数据</LoadMore>
        ) : (
          <div>
            <Button
              color="primary"
              variant="contained"
              size="small"
              className="perListChartBt"
              onClick={() => {
                listChartClick();
              }}
            >
              {perListChartTxt}
            </Button>
            {isShowList ? (
              <div className="mp-table">
                <div className="mp-table-tr mp-table-header">
                  <div>绩效日期</div>
                  <div>绩效等级</div>
                  <div>绩效评分</div>
                </div>
                {list.map((item, index) => (
                  <div className="mp-table-tr" key={index}>
                    <div>{item.assessmentMonth}</div>
                    <div>
                      <div className={['u-level', item.gradeInfo].join(' ')}>
                        {item.gradeInfo}
                      </div>
                    </div>
                    <div>{formatNumber(item.assessmentScore, 2)}</div>
                  </div>
                ))}
              </div>
            ) : (
              <CardContent style={{ padding: '20px' }} className="chartRadar">
                <div className={['gradeInfo', 'level-' + gradeInfo].join(' ')}>
                  {gradeInfo}级
                </div>
                <ReactEcharts
                  option={chartOpt1}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}

SupplierDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierDetail);
